import type { FC } from 'react';
import { Alert } from '@reverse-hr/pattern-library';
import type {
  TAlertDetail,
  TShareLinkModalAlertProps,
} from '@components/ShareLinkModal/ShareLinkModal.types';

export const ShareLinkModalAlert: FC<TShareLinkModalAlertProps> = props => {
  const { alertDetail, setAlertDetail } = props;

  return (
    <div className="rev-o-container rev-o-container--full">
      <div className="rev-o-grid">
        {alertDetail.visible ? (
          <div className="rev-o-col-12 rev-u-px-16 rev-u-mt-24">
            <Alert
              modifier=""
              closable
              type={alertDetail.type}
              icon={alertDetail.icon}
              onClose={() =>
                setAlertDetail((prev: TAlertDetail) => ({
                  ...prev,
                  visible: false,
                }))
              }
            >
              {alertDetail.children}
            </Alert>
          </div>
        ) : null}
      </div>
    </div>
  );
};
